import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import PrintMapRoute from './PrintMapRoute';
import PrintMapRouteInfo from './PrintMapRouteInfo';
import moment from "moment";
import { parseQuery } from "HelperFunctions/QueryString";
import PrintDispatchSummary from './PrintDispatchSummary';
import PrintFullInventorySheet from './PrintFullInventorySheet';
import PrintDeliveryManifest from './PrintDeliveryManifest';
import service from 'Api/service';

// Description: The route print page
class PrintMapRoutePrintables extends React.Component {
  state = {
    stops: [],
    routeInfo: null,
    directions: null,
    loadListsHtmlPages: [],
    loadListsIframeDimensions: [],
  };

  UNSAFE_componentWillMount() {
    const { truckRoute } = this.props;
    this.setState({
      startTime: truckRoute.startTime,
      stops: truckRoute.stops,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      const { fetchTruckRoute } = this.props;
      fetchTruckRoute(nextProps.match.params.id);
    }
  }

  componentDidMount() {
    const { fetchTruckRoute } = this.props;
    fetchTruckRoute(this.props.match.params.id);
    if (window.location.href.includes('loadLists')) {
      this.fetchLoadListsHtml();
    }
  }

  fetchLoadListsHtml = () => {
    if (this.loadListsFetchStarted) return;
    this.loadListsFetchStarted = true;

    const truckRouteId = this.props.match.params.id;
    service
      .get(
        import.meta.env.VITE_API_DOMAIN +
          `/api/print/truck_routes/${truckRouteId}/loadlist`
      )
      .then((response) => {
        const pages = response.data.contents || [];
        this.setState({
          loadListsHtmlPages: pages,
          loadListsIframeDimensions: pages.map(() => ({ width: 0, height: 0 })),
        });
      })
      .catch((error) => {
        this.loadListsFetchStarted = false;
        console.error('Failed to fetch load lists HTML', error);
      });
  };

  handleLoadListsIframeLoad = (index) => (event) => {
    const iframe = event.target;
    try {
      const doc = iframe.contentDocument;
      const body = doc?.body;
      if (!body) return;
      body.style.margin = '0';

      const style = doc.createElement('style');
      style.textContent = `
        html, body { overflow: hidden !important; }
        .printWrapper {
          min-height: 0 !important;
          margin-bottom: 0 !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }
      `;
      doc.head?.appendChild(style);

      this.setState((state) => {
        const next = [...state.loadListsIframeDimensions];
        next[index] = { width: body.scrollWidth, height: body.scrollHeight };
        return { loadListsIframeDimensions: next };
      });
    } catch (e) {
      console.warn('Failed to measure load lists iframe', e);
    }
  };
  
  handleDirectionChange = (response) => {
    this.setState({ routeInfo: response.routes[0] });
  };

  render() {
    const {
      truckRoute,
      loading 
    } = this.props;
    const { withMap } = parseQuery(window.location.search);
    const { name, startTime, stops, routeStart, routeEnd } = truckRoute;
    const { directions, routeInfo } = this.state;
    let legs = [];
    let totalDuration = "";
    if (directions) {
      legs = directions.legs;
      let arrivalTime = moment(startTime);
      legs = legs.map((leg, index) => {
        const duration = leg.duration.value;
        arrivalTime = moment(arrivalTime).second(
          arrivalTime.second() + duration
        );
        const result = {
          duration: moment.duration(duration, "seconds").humanize(),
          arrivalTime: arrivalTime.toDate()
        };
        if (index < legs.index - 1) {
          arrivalTime = moment(arrivalTime).minute(
            arrivalTime.minute() + stops[index].setupTime
          );
        }
        return result;
      });
      totalDuration = moment
        .duration(arrivalTime.diff(moment(startTime)))
        .humanize();
    }

    let stopNumberCounter = 0;
    const stopNumbers = stops.map((stop) => {
      if (stop.stopType === 'custom' && !stop.physicalAddress) {
        return '';
      } else {
        stopNumberCounter++;
        return stopNumberCounter;
      }
    });
    
    let includeLocationsWithMap = window.location.href.includes('locationsWithMap')
    let includeTurnByTurnWithMap = window.location.href.includes('turnByTurnWithMap')
    let includeLocationsOnly = window.location.href.includes('locationsOnly')
    let includeTurnByTurnOnly = window.location.href.includes('turnByTurnOnly')
    let includeDispatchSummary = window.location.href.includes('dispatchSummary')
    let includeFullInventorySheet = window.location.href.includes('fullInventorySheet')
    let includeDeliveryManifest = window.location.href.includes('deliveryManifest')
    let includeLoadLists = window.location.href.includes('loadLists')

    return (
      <div>
        {includeLocationsWithMap &&
          <PrintMapRoute
            truckRoute={truckRoute}
            withMap={withMap}
            loading={loading}
            name={name}
            startTime={startTime}
            directions={directions}
            totalDuration={totalDuration}
            stops={stops}
            routeInfo={routeInfo}
            routeStart={routeStart}
            stopNumbers={stopNumbers}
            legs={legs}
            handleDirectionChange={this.handleDirectionChange}
            match={this.props.match}
          />
        }
        {includeTurnByTurnWithMap &&
          <PrintMapRouteInfo
            truckRoute={truckRoute}
            withMap={withMap}
            loading={loading}
            name={name}
            startTime={startTime}
            directions={directions}
            totalDuration={totalDuration}
            stops={stops}
          />
        }
        {includeLocationsOnly &&
          <PrintMapRoute
            truckRoute={truckRoute}
            withMap={undefined}
            loading={loading}
            name={name}
            startTime={startTime}
            directions={directions}
            totalDuration={totalDuration}
            stops={stops}
            routeInfo={routeInfo}
            routeStart={routeStart}
            stopNumbers={stopNumbers}
            legs={legs}
            handleDirectionChange={this.handleDirectionChange}
            match={this.props.match}
          />
        }
        {includeTurnByTurnOnly &&
          <PrintMapRouteInfo
            truckRoute={truckRoute}
            withMap={undefined}
            loading={loading}
            name={name}
            startTime={startTime}
            directions={directions}
            totalDuration={totalDuration}
            stops={stops}
          />
        }
        { includeDispatchSummary &&
          <PrintDispatchSummary
            truckRoute={truckRoute}
            match={this.props.match}
          />
        }
        { includeFullInventorySheet &&
          <PrintFullInventorySheet
            match={this.props.match}
          />
        }
        { includeDeliveryManifest &&
          <PrintDeliveryManifest
            match={this.props.match}
          />
        }
        { includeLoadLists && this.state.loadListsHtmlPages.map((htmlPage, index) => {
          const dims = this.state.loadListsIframeDimensions[index] || {};
          return (
            <iframe
              key={index}
              title={`Load Lists ${index + 1}`}
              srcDoc={htmlPage}
              sandbox='allow-same-origin'
              onLoad={this.handleLoadListsIframeLoad(index)}
              style={{
                width: dims.width ? `${dims.width}px` : '100%',
                height: dims.height ? `${dims.height}px` : '100vh',
                border: 'none',
                margin: 0,
                padding: 0,
                display: 'block',
                pageBreakBefore: 'always',
                breakBefore: 'page',
              }}
            />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { truckRoute, loading } = state.truckRoute;
  return { truckRoute, loading };
};

export default connect(mapStateToProps, actions)(PrintMapRoutePrintables);
